
import { GlobalContext } from '../../../../../utils/globalprovider';
import { forwardRef, useCallback, useContext } from 'react';
import './mergespeakerform.css';

const MergeSpeakerForm = forwardRef((props, ref) => {
  const context = useContext(GlobalContext);
  const lang = context.language;

  const onSelectSpeaker = useCallback(
    (event) => {
      if (props.onSelectSpeaker) {
        props.onSelectSpeaker(event.target.value);
      }
    },
    [props]
  );

  return (
    <>
      <div className="mergeContainer">
        <div className="group">
          <label htmlFor="selectSpeakers">
            {lang === 'fr'
              ? 'Choisir le speaker à fusionner'
              : 'Select the speaker to merge'}
          </label>
          <select
            name="selectSpeakers"
            id="selectSpeakers"
            defaultValue="-1"
            onChange={onSelectSpeaker}
          >
            <option value="-1" disabled></option>
            {props.speakers.map((item) => {
              return (
                <option value={item.id} key={'speaker' + item.id}>
                  {item.firstname} {item.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </>
  );
});

export default MergeSpeakerForm;
